import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FiMoreHorizontal } from "react-icons/fi";
import { Dropdown } from 'react-bootstrap';
import CustomFieldEditModal from 'components/CustomFields/CustomFieldEditModal';
import { showModal, hideModal } from "actions/modalActions";
import * as customFieldsActions from 'actions/customFieldsActions';
import { customFieldsService } from "services";
import { errorFormating } from "utils/utils";
import DataTable from "components/DataTable";
import { withTranslation } from 'react-i18next';

export const CUSTOM_FIELDS_TYPES = [{
  type: "TEXT",
  label: "Texto"
},
{
  type: "TEXT_AREA",
  label: "Texto ampliado"
},
{
  type: "NUMBER",
  label: "Numérico"
},
{
  type: "DATE",
  label: "Fecha"
},
];

class CustomFieldsList extends Component {
  constructor(props) {
    super(props);
    // console.log(props);
    this.closeModal = this.closeModal.bind(this);
    this.openEditCustomFieldModal = this.openEditCustomFieldModal.bind(this);
    this.openDeleteCustomFieldModal = this.openDeleteCustomFieldModal.bind(this);
    this.openAlertModal = this.openAlertModal.bind(this);
  }

  closeModal() {
    this.props.hideModal()
  }

  openEditCustomFieldModal(custom_field) {
    this.props.showModal({
      open: true,
      title: this.props.t('customFields.editField'),
      style: { width: '400px' },
      content: <CustomFieldEditModal custom_field={custom_field} handleClose={this.closeModal} />,
      closeModal: this.closeModal
    }, 'edit')
  }

  openDeleteCustomFieldModal(idCustomField) {
    this.props.showModal({
      open: true,
      title: this.props.t('customFields.deleteField'),
      style: { width: '400px' },
      message: this.props.t('customFields.deleteConfirmation'),
      deleteAction: () => this.confirmDelete(idCustomField),
      closeModal: this.closeModal
    }, 'delete')
  }

  openAlertModal(message) {
    this.props.showModal({
      open: true,
      title: this.props.t("customFields.deleteError"),
      style: { width: '400px' },
      message: message,
      closeModal: this.closeModal
    }, 'alert')
  }

  confirmDelete = async (idCustomField) => {
    const response = await customFieldsService.remove(idCustomField);

    if (!response.ok) {
      let textError = errorFormating(response);
      this.openAlertModal(textError.id);
    }
    else {
      this.props.getAllCustomFields();
      this.closeModal();
    }
  }

  TYPE_KEYS = { TEXT: "customFields.types.text", TEXT_AREA: "customFields.types.textArea", NUMBER: "customFields.types.number", DATE: "customFields.types.date" };

  getTypeLabel = (type) => {
    return this.props.t(this.TYPE_KEYS[type] || type || "—");
  }

  getCustomFieldColumns = () => [
    {
      key: "name",
      header: this.props.t("customFields.headerName"),
      render: (custom_field) => (
        <button
          type="button"
          className="btn-transparent btn-editable"
          onClick={() => this.openEditCustomFieldModal(custom_field)}
        >
          {custom_field.name}
        </button>
      ),
    },
    {
      key: "type",
      header: this.props.t("customFields.headerType"),
      render: (custom_field) => this.getTypeLabel(custom_field.type),
    },
  ];

  render() {
    const custom_fields = this.props.custom_fields || [];

    return (
      <DataTable
        tableClassName="table-custom-fields table-hover"
        tableStyle={{ backgroundColor: "#ffffff" }}
        columns={this.getCustomFieldColumns()}
        rows={custom_fields}
        rowKey={(row) => row.id}
        emptyMessage={this.props.t("common.noResults")}
        actionsColumn={{
          render: (custom_field) => (
            <Dropdown>
              <Dropdown.Toggle variant="action">
                <FiMoreHorizontal />
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item
                  as="button"
                  onClick={() => this.openEditCustomFieldModal(custom_field)}
                >
                  {this.props.t("common.edit")}
                </Dropdown.Item>
                <Dropdown.Item
                  as="button"
                  onClick={() => this.openDeleteCustomFieldModal(custom_field.id)}
                >
                  {this.props.t("common.delete")}
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          ),
          className: "td-actions",
        }}
      />
    );
  }
}


const mapStateToProps = (reducers) => {
  return reducers.customFieldsReducer;
};

const mapDispatchToProps = dispatch => ({
  hideModal: () => dispatch(hideModal()),
  showModal: (modalProps, modalType) => {
    dispatch(showModal({ modalProps, modalType }))
  },
  getAllCustomFields: (options) => dispatch(customFieldsActions.getAllCustomFields(options)),
})


export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(CustomFieldsList))